import React, { useEffect } from 'react';
import { makeStyles, createStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
        display: "none"
    },
  }),
);

export interface RenderImage {
  src: string
  img?: CanvasImageSource
  x: number
  y: number
  w: number
  h: number
}

export interface Highlight {
    highlight?: string
}

export interface SpriteDefine {
  body: {
    [color: string]: {
      head: RenderImage
      body: RenderImage
      rightArm: RenderImage
      leftArm: RenderImage
    }
  },
  shirt: {
    [key: string]: {
      body: RenderImage
      rightArm: RenderImage
      leftArm: RenderImage
    }
  },
  jacket: {
    [key: string]: {
      body: RenderImage
      rightArm: RenderImage
      leftArm: RenderImage
    }
  },
  hair: {
    [key: string]: RenderImage & Highlight
  },
  eye: {
    [key: string]: RenderImage & Highlight
  },
  mouth: {
    [key: string]: RenderImage
  },
  highlight: {
    [key: string]: RenderImage
  },
  accessory: {
    [key: string]: RenderImage
  },
  background: {
    [key: string]: RenderImage
  },
  table: {
    [key: string]: RenderImage
  }
  pc: {
    [key: string]: RenderImage
  }
}

interface Props {
    ready?: (define: SpriteDefine)=>void
}

function SpriteManager(props: Props) {

    const classes = useStyles()

    const [json, setJson] = React.useState<SpriteDefine|undefined>()
    useEffect(()=>{
        const func = async ()=>{
            const response = await fetch("/Asset/asset.json")
            if (response.ok) {
                setJson(await response.json())
            }
        }
        func()
    }, [])

    useEffect(()=>{

      const resultMap: {[key:string]:RenderImage[]} = {}
      const renderPush = (render: RenderImage) => {
        if (!resultMap[render.src]) {resultMap[render.src] = []}
        resultMap[render.src].push(render)
      }

      for (const [,body] of Object.entries(json?.body || {})) {
        renderPush(body.head)
        renderPush(body.body)
        renderPush(body.leftArm)
        renderPush(body.rightArm)
      }
      for (const [,shirt] of Object.entries(json?.shirt || {})) {
        renderPush(shirt.body)
        renderPush(shirt.leftArm)
        renderPush(shirt.rightArm)
      }
      for (const [,jacket] of Object.entries(json?.jacket || {})) {
        renderPush(jacket.body)
        renderPush(jacket.leftArm)
        renderPush(jacket.rightArm)
      }
      for (const [, hair] of Object.entries(json?.hair || {})) {
        renderPush(hair)
      }
      for (const [, eye] of Object.entries(json?.eye || {})) {
        renderPush(eye)
      }
      for (const [, mouth] of Object.entries(json?.mouth || {})) {
        renderPush(mouth)
      }
      for (const [, highlight] of Object.entries(json?.highlight || {})) {
        renderPush(highlight)
      }
      for (const [, accessory] of Object.entries(json?.accessory || {})) {
        renderPush(accessory)
      }
      for (const [, background] of Object.entries(json?.background || {})) {
        renderPush(background)
      }
      for (const [, table] of Object.entries(json?.table || {})) {
        renderPush(table)
      }
      for (const [, pc] of Object.entries(json?.pc || {})) {
        renderPush(pc)
      }
      setSrcMap(resultMap)

    }, [json])
    const [srcMap, setSrcMap] = React.useState<{[key:string]:RenderImage[]}>({})

    const [srcLength, setSrcLength] = React.useState(0)
    useEffect(()=>{
      if (srcLength !== 0 && Object.keys(srcMap).length === srcLength) {
        if (json) {
          props?.ready?.(json)
        } 
      }
    },[props, srcMap, srcLength, json])

    return (
        <div className={classes.root}>
            { srcMap ? Object.entries(srcMap).map(([src])=>(
                <img 
                    src={src} 
                    alt="splite"
                    key={src} 
                    onLoad={(event)=>{
                        console.log(src)
                        srcMap[src].map(render=>render.img = event.currentTarget)
                        setSrcLength(srcLength + 1)
                    }} 
                />
            )) : null }
        </div>
    )
}

export default SpriteManager;